import {readAndParseItsDangerousCookie} from "./utils";
import React, {useContext, useReducer} from "react";
import {mapEntries} from "radash";

export const apiSessionReducer = (state, action) => {
    switch (action.name) {
        case "init": {
            return {
                data: {},
                logout: action.logout
            }
        }
        case "refreshSession": {
            const data = readAndParseItsDangerousCookie('session')

            if(action.logLevel > LOG_LEVELS.SILENT) {
                console.log(`refresh session, will expire in ${data.session_timeout_in_seconds/60} minutes`)
            }

            if (state.interval) {
                clearInterval(state.interval)
            }

            return {
                ...state,
                data,
                isLoggedIn: true,
                interval: setInterval(() => {
                    action.triggerSessionExpiry()
                }, data.session_timeout_in_seconds * 1000)
            }
        }
        case "expireSession": {

            return {
                ...state,
                loggedIn: false,
                sessionHasExpired: true
            }
        }
    }
}

const ApiContext = React.createContext()

const ApiSessionContext = React.createContext()

export function useApi() {
  return useContext(ApiContext)
}

export function useApiSession() {
  return useContext(ApiSessionContext)
}

export const LOG_LEVELS = {
    DEBUG: 2,
    VERBOSE: 1,
    SILENT: 0
}


export const ApiProvider = ({apiDict, children, afterLogoutFunc, onSessionExpired, logLevel= LOG_LEVELS.SILENT}) => {

    const logout = () => {
        function delete_cookie(name) {
            document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
        }
        delete_cookie('session')
        if(afterLogoutFunc) {
            afterLogoutFunc()
        }
    }


    const [session, sessionDispatch] = useReducer(
        apiSessionReducer,
        apiSessionReducer(null, {name: 'init', apiDict, logout})
    )

    const triggerSessionExpiry = () => {
        sessionDispatch({name: "expireSession"})
        if(onSessionExpired) {
            onSessionExpired(session)
        }
    }

    const api = mapEntries(apiDict, (funcName, apiFunc) => {
        return [funcName, function() {
            return apiFunc(...arguments).then(res => {
                return new Promise((resolve, reject) => {
                    if(res.status === 200) {
                        sessionDispatch({name: 'refreshSession', triggerSessionExpiry, logLevel})
                        return resolve(res.json())
                    }
                    else {
                        reject(res)
                    }
                })
            })
        }]
    })


    return <ApiSessionContext.Provider value={{...session}}>
        <ApiContext.Provider
            value={api}
        >
            {children}
        </ApiContext.Provider>
    </ApiSessionContext.Provider>
}
